import { pickT } from "@repo/shared";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";
import { T } from "./flow-progress-bar.i18n";

type FieldProgressBarProps = {
  filledCount: number;
  totalCount: number;
  percent: number;
  className?: string;
  /** Width of the bar itself; the public header stretches it (QL-682). */
  barClassName?: string;
  /**
   * Picks the words explicitly (not `useT`): the advisor wizard renders this
   * without a language, which has always meant English.
   */
  language?: string;
};

export function FieldProgressBar({
  filledCount,
  totalCount,
  percent,
  className,
  barClassName = "w-48",
  language = "en_GB",
}: FieldProgressBarProps) {
  const t = pickT(T, language);
  const clamped = Math.max(0, Math.min(100, totalCount === 0 ? 100 : percent));

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-muted-foreground">
          {t.xOfYAnswered(filledCount, totalCount)}
        </span>
        <span className="text-xs font-medium text-muted-foreground">{clamped}%</span>
      </div>
      <Progress value={clamped} className={cn("h-2", barClassName)} />
    </div>
  );
}
